<template>
  <div>
    <vx-card>
      <div class="vx-card__header p-0">
        <!-- card title -->
        <div class="vx-card__title">
          <h4>Perbarui Data</h4>
        </div>

        <!-- card actions -->
        <div class="vx-card__actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveCompany()">Simpan Data</vs-button>
              <vs-button to="/company" class="ml-4 mt-2" type="border" color="danger">Batal</vs-button>
            </div>
          </div>
        </div>
      </div>

      <div class="divider my-2"></div>

      <div class="vx-card__body">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="Nama Perusahaan" v-model="form.name" v-validate="'required|alpha_spaces'" name="name" />
                <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="NPWP" v-model="form.npwp" v-validate="'required|numeric'" name="npwp" />
                <span class="text-danger text-sm" v-show="errors.has('npwp')">{{ errors.first('npwp') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="Email" v-model="form.email" v-validate="'required|email|min:3'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="No. Handphone" v-model="form.phone" v-validate="'required|numeric'" name="phone" />
                <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input ref="password" class="w-full mt-4" label="Initial Balance" v-model="form.init_balance" v-validate="'required|numeric'" name="init_balance" />
                <span class="text-danger text-sm" v-show="errors.has('init_balance')">{{ errors.first('init_balance') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="Final Balance" v-model="form.final_balance" name="final_balance" />
                <span class="text-danger text-sm"  v-show="errors.has('final_balance')">{{ errors.first('final_balance') }}</span>
              </div>
            </div>
            <div class="w-full mt-4">
              <vs-input class="w-full mt-4" label="Website" v-model="form.website" name="website" />
              <span class="text-danger text-sm"  v-show="errors.has('website')">{{ errors.first('website') }}</span>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Alamat</label>
              <vs-textarea class="w-full" v-model="form.address" name="address" />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="url" class="rounded mr-4" width="300" height="300" />
              <div>
                <input type="file" @change="addLogo" class="hidden" ref="update_logo_input" accept="image/*">
                <vs-button  @click="$refs.update_logo_input.click()" class="mr-4 mb-2" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                <vs-button @click="removeLogo()" type="border" color="danger" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleCompany from '@/store/companies/moduleCompany.js'

export default {
  data () {
    return {
      form:{
        address: null,
        email: null,
        phone: null,
        website: null,
        logo: null,
        init_balance: 0,
        final_balance: 0
      },

      url: null
    }
  },
  created () {
    if (!moduleCompany.isRegistered) {
      this.$store.registerModule('company', moduleCompany)
      moduleCompany.isRegistered = true
    }

    this.findCompany()
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
        this.name !== '' &&
        this.npwp !== '' &&
        this.init_balance !== ''  &&
        this.final_balance !== ''
    }
  },
  methods: {
    addLogo (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
      this.form.logo = file
    },

    removeLogo () {
      this.url = null
      this.form.logo = null
    },

    findCompany () {
      this.$store.dispatch('company/findCompany', this.$route.params.id)
        .then(({data: {data: {company}}}) => {
          // assign the form
          this.form.name = company.name
          this.form.npwp = company.npwp
          this.form.email = company.email
          this.form.phone = company.phone
          this.form.address = company.address
          this.form.website = company.website
          this.form.init_balance = company.init_balance
          this.form.final_balance = company.last_balance
          this.url = `${this.$storagePath + company.logo}`
        })
        .catch(({response: { data: err }}) => console.log(err.message))
    },

    saveCompany () {
      const self = this

      this.$validator.validateAll().then(result => {
        if (result) {

          const formData = new FormData()
          formData.set('name', self.form.name)
          formData.set('npwp', self.form.npwp)
          formData.set('address', self.form.address)
          formData.set('email', self.form.email)
          formData.set('phone', self.form.phone)
          formData.set('website', self.form.website)
          formData.set('init_balance', self.form.init_balance)
          formData.set('final_balance', self.form.final_balance)
          formData.append('logo', self.form.logo)
          formData.append('_method', 'PUT')

          this.$store.dispatch('company/updateCompany', {
            id: this.$route.params.id,
            data: formData
          })
            .then(function () {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Perusahaan berhasil di tambahkan'
              })
              self.$router.push('/company')
            })
            .catch(err => {
              self.$vs.notify({
                color: 'danger',
                title: 'Oops..',
                text: err.response.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.divider {
  background: #E0E0E0;
  height: 1px;
}
</style>
